export const Folder = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_199_26121'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='1'
      y='3'
      width='18'
      height='14'
    >
      <path
        d='M2.5 6.375C2.5 5.27043 3.39543 4.375 4.5 4.375H6.83333C7.26607 4.375 7.68714 4.51536 8.03333 4.775L9.46667 5.85C9.81286 6.10964 10.2339 6.25 10.6667 6.25H15.5C16.6046 6.25 17.5 7.14543 17.5 8.25V14.25C17.5 15.3546 16.6046 16.25 15.5 16.25H4.5C3.39543 16.25 2.5 15.3546 2.5 14.25V6.375Z'
        stroke='black'
        strokeWidth='1.25'
      />
    </mask>
    <g mask='url(#mask0_199_26121)'>
      <path d='M20 0H0V20H20V0Z' fill='white' fillOpacity='0.5' />
    </g>
  </svg>
)
